import React, { useEffect, useState } from 'react';
import TransactionApi from '../api/TransactionApi';

// Utility function to get month names by number
const getMonthName = (monthNumber) => {
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  return months[monthNumber];
};

const IncomeReport = () => {
  const [categoryIncomes, setCategoryIncomes] = useState({});
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalIncomes, setTotalIncomes] = useState(Array(12).fill(0));
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [transactions, setTransactions] = useState([]); 


  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await TransactionApi.incomes(); 
      setTransactions(res); 
      setIsLoading(false);
    };

    fetchData();
  }, []);


  useEffect(() => {
    if (transactions.length > 0) {
      fetchYears(); 
      getTransactions();
    }
  }, [transactions, selectedYear]);

  const fetchYears = () => {
    const uniqueYears = [
      ...new Set(transactions.map((transaction) => new Date(transaction.paid_at).getFullYear()))
    ];
    setYears(uniqueYears);

    if (!uniqueYears.includes(new Date().getFullYear())) {
      setSelectedYear(uniqueYears[0]);
    }
  };

  const getTransactions = () => {
    const categoryData = {};
    
    transactions.forEach((transaction) => {
      const { amount, paid_at, type, cat_name } = transaction;
      const parsedAmount = parseFloat(amount);
      const date = new Date(paid_at);
      const monthIndex = date.getMonth();
      const year = date.getFullYear();

      if (year === selectedYear && type === 'income') {
        const categoryName = cat_name || 'Uncategorized';
        if (!categoryData[categoryName]) {
          categoryData[categoryName] = Array(12).fill(0);
        }
        categoryData[categoryName][monthIndex] += parsedAmount;
      }
    });

    const totalIncomes = Array(12).fill(0).map((_, monthIndex) => {
      return Object.values(categoryData).reduce(
        (sum, monthlyData) => sum + monthlyData[monthIndex],
        0
      );
    });

    const newCategoryIncomes = {};
    for (const [catName, monthlyData] of Object.entries(categoryData)) {
      newCategoryIncomes[catName] = monthlyData;
    }

    setCategoryIncomes(newCategoryIncomes);

    const total = totalIncomes.reduce((sum, income) => sum + income, 0);
    setTotalIncome(total);
    setTotalIncomes(totalIncomes);
  };

  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value));
  };

  return (
    <div>
      {isLoading ? (
        <div className="loading">
          <p>Loading...</p>
          {/* Add a spinner if you want */}
        </div>
      ) : (
      <div className="mx-auto">
        <div className="flex flex-col">
          <div className="flex justify-end mb-4">
            <select value={selectedYear} onChange={handleYearChange} className="p-2 border rounded w-20">
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Income Name
                      </th>
                      {Array.from({ length: 12 }, (_, i) => (
                        <th
                          key={i}
                          scope="col"
                          className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                        >
                          {getMonthName(i)}
                        </th>
                      ))}
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {Object.entries(categoryIncomes).map(([catName, incomes]) => (
                      <tr key={catName} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                          {catName}
                        </td>
                        {incomes.map((income, index) => (
                          <td
                            key={index}
                            className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            {income.toFixed(2)}
                          </td>
                        ))}
                        <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                        {incomes.reduce((total, num) => total + num, 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}

                    <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                        Total
                      </td>
                      {totalIncomes.map((income, index) => (
                        <td
                          key={index}
                          className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {income.toFixed(2)}
                        </td>
                      ))}
                      <td scope="col" className="py-3 px-6 text-xs  font-medium  tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                      {totalIncome.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                  Total Yearly Income: {totalIncome.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default IncomeReport;
